import { cva } from "styled-system/css";

export const input = cva({
  base: {
    width: "100%",
    backgroundColor: "bgBase100",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "bgBase300",
    borderRadius: "medium",
    color: "textBase",
    fontFamily: "sans",
    fontSize: "base",
    paddingY: "sm",
    paddingX: "md",
    transitionProperty: "border-color, box-shadow",
    transitionDuration: "0.2s",
    outline: "none",
    _focus: {
      borderColor: "primary",
      boxShadow: "0 0 0 2px color-mix(in srgb, {colors.primary}, transparent 80%)",
    },
    _disabled: {
      backgroundColor: "bgBase200",
      cursor: "not-allowed",
      opacity: 0.7,
    },
    _placeholder: {
      color: "textMuted",
      opacity: 0.5,
    },
  },
  variants: {
    inputSize: {
      small: {
        fontSize: "sm",
        paddingY: "xs",
        paddingX: "sm",
      },
      medium: {},
    },
    variant: {
      default: {},
      ghost: {
        backgroundColor: "transparent",
        borderWidth: "0",
        borderColor: "transparent",
        boxShadow: "none",
        paddingY: 0,
        paddingX: 0,
        _focus: {
          borderColor: "transparent",
          boxShadow: "none",
        },
      },
    },
    error: {
      true: {
        borderColor: "error",
        _focus: {
          borderColor: "error",
          boxShadow: "0 0 0 2px color-mix(in srgb, {colors.error}, transparent 80%)",
        },
      },
    },
    textarea: {
      true: {
        minHeight: "100px",
        resize: "vertical",
      },
    },
  },
});
